import React from 'react';

import Question from '../elements/question';
import Feedback from '../elements/feedback';
import {SubsidieBox, WarningBox} from '../elements/infoboxes'
import state from '../zviz3/state';
import { ConnectState } from '../zviz3/Connect';
import { checkConditions } from '../helpers/conditions';
import Icon from '../elements/icon';

const getSquareMeters = function(){
    const houseType = state.get('answers.a4');
    if(houseType==='vrijstaand'){
        return 50;
    }else if(houseType==='halfvrijstaand'){
        return 33;
    }else if(houseType==='tussenwoning'){
        return 15;
    }else if(houseType==='etagewoning'){
        return 13;
    }
    return 'de vereiste ';
}

const questions = [
    {
        name: 'b1',
        question: 'Kiest u voor isolatie aangebracht in de spouwmuren van uw woning?',
        explanation: null,
        options: [
            {value: true, label: 'Ja'},
            {value: false, label: 'Nee'}
        ],
        conditions: [ 
            {variable: 'a', value: true, type: 'equal'},
        ]
    },
    {
        name: 'b2',
        question: 'Voldoet het gebruikte isolatiemateriaal aan de gestelde voorwaarden?',
        explanation: 'Het gebruikte isolatiemateriaal moet een Rd-waarde van ten minste 1,1 m\u00b2K/W hebben. De Rd-waarde is de, door de fabrikant aangegeven, isolatiewaarde van een materiaal. De d staat in dit geval voor ‘declared’. Een isolatiemateriaal heeft altijd een specifieke Rd-waarde, uitgedrukt in m\u00b2K/W. Hoe hoger de uitkomst, hoe beter de warmteweerstand (en dus de isolatiewaarde). Kort gezegd; materiaal met een hoge Rd-waarde is beter in staat om in de winter de warmte in uw huis te houden en in de zomer juist er buiten.',
        options: [
            {value: true, label: 'Ja'},
            {value: false, label: 'Nee'}
        ],
        conditions: [
            {variable: 'b1', value: true, type: 'equal'}
        ]
    },
    {
        name: 'b3',
        question: () => ('Is het muuroppervlak waar u spouwmuurisolatie heeft toegepast meer dan ' + getSquareMeters() + 'm\u00b2?'),
        explanation: null,
        options: [
            {value: true, label: 'Ja'},
            {value: false, label: 'Nee'}
        ],
        conditions: [
            {variable: 'b2', value: true, type: 'equal'}
        ]
    },
    {
        name: 'b4',
        question: () => ('Is het muuroppervlak van uw gehele woning minder dan ' + getSquareMeters() + 'm\u00b2?'),
        explanation: null,
        options: [
            {value: true, label: 'Ja'},
            {value: false, label: 'Nee'}
        ],
        conditions: [
            {variable: 'b3', value: false, type: 'equal'},
        ]
    },
    {
        name: 'b5',
        question: 'Kiest u voor binnen- en/of buitengevelisolatie aangebracht bij de gevels (anders dan spouwmuurisolatie) in uw woning?',
        explanation: null,
        options: [
            {value: true, label: 'Ja'},
            {value: false, label: 'Nee'}
        ],
        conditions: [
            {variable: 'b4', value: null, type: 'not_equal'},
            {variable: 'b3', value: true, type: 'equal'},
            {variable: 'b1', value: false, type: 'equal'},
            {variable: 'b2', value: false, type: 'equal'}
        ]
    },
    {
        name: 'b6',
        question: 'Voldoet het gebruikte isolatiemateriaal aan de gestelde voorwaarden?',
        explanation: 'Het gebruikte isolatiemateriaal moet een Rd-waarde van ten minste 3,5 m\u00b2K/W hebben. De Rd-waarde is de, door de fabrikant aangegeven, isolatiewaarde van een materiaal. De d staat in dit geval voor ‘declared’. Een isolatiemateriaal heeft altijd een specifieke Rd-waarde, uitgedrukt in m\u00b2K/W. Hoe hoger de uitkomst, hoe beter de warmteweerstand (en dus de isolatiewaarde). Kort gezegd; materiaal met een hoge Rd-waarde is beter in staat om in de winter de warmte in uw huis te houden en in de zomer juist er buiten.',
        options: [
            {value: true, label: 'Ja'},
            {value: false, label: 'Nee'}
        ],
        conditions: [
            {variable: 'b5', value: true, type: 'equal'}
        ]
    },
    {
        name: 'b7',
        question: () => ('Is het muuroppervlak waar u gevelmuurisolatie heeft toegepast meer dan ' + getSquareMeters() + 'm\u00b2?'),
        explanation: null,
        options: [
            {value: true, label: 'Ja'},
            {value: false, label: 'Nee'}
        ],
        conditions: [
            {variable: 'b6', value: true, type: 'equal'}
        ]
    },
    {
        name: 'b8',
        question: () => ('Is het muuroppervlak van uw gehele woning minder dan ' + getSquareMeters() + 'm\u00b2?'),
        explanation: null,
        options: [
            {value: true, label: 'Ja'},
            {value: false, label: 'Nee'}
        ],
        conditions: [
            {variable: 'b7', value: false, type: 'equal'},
        ]
    }
]

const condSpouwmuur = [
    {variable: 'b3', value: true, type: 'equal'},
    {variable: 'b4', value: true, type: 'equal'}
];
const condGevel = [
    {variable: 'b7', value: true, type: 'equal'},
    {variable: 'b8', value: true, type: 'equal'}
];

export const getSubsidies = function(){
    let text = [];
    if(checkConditions(condSpouwmuur)){
        text.push("Spouwmuurisolatie € 5,00 per m\u00b2");
    }
    if(checkConditions(condGevel)){
        text.push("Gevelisolatie € 25,00 per m\u00b2");
    }
    return text;
}

const feedback = [
    {
        content: () => (<SubsidieBox text={getSubsidies()} />),
        name: 'b',
        value: true,
        conditions: [
            {type: 'and', conditions: [
                {type: 'group', conditions: [...condSpouwmuur, ...condGevel]},
                {type: 'group', conditions: [
                    {variable: 'b8', value: null, type: 'not_equal'},
                    {variable: 'b7', value: true, type: 'equal'},
                    {variable: 'b6', value: false, type: 'equal'},
                    {variable: 'b5', value: false, type: 'equal'},
                ]},
            ]}
        ]    
    },
    {
        content: <WarningBox text="U komt niet in aanmerking voor subsidie voor het isoleren van uw muren" />,
        name: 'b',
        value: true,
        conditions: [
            {type: 'and', conditions: [
                {type: 'group', conditions: [
                    {variable: 'b5', value: false, type: 'equal'},
                    {variable: 'b6', value: false, type: 'equal'},
                    {variable: 'b8', value: false, type: 'equal'}
                ]},
                {type: 'and', conditions: [
                    {variable: 'b3', value: true, type: 'not_equal'},
                    {variable: 'b4', value: true, type: 'not_equal'},
                    {variable: 'b7', value: true, type: 'not_equal'},
                    {variable: 'b8', value: true, type: 'not_equal'}
                ]}
            ]},

        ]    
    },
];

function SectionB(props){
    
    if(checkConditions({variable: 'a6', value: 'muur', type: 'includes'})){
        return <div className="seehi_section">
            <h2 className="seehi_iconHeader"><Icon type="muren" />Muren</h2>
            <p>Binnen de subsidieregeling vallen 2 type isolatiemaatregelen: spouwmuurisolatie en/of gevelisolatie.</p>

            {questions.map((props, i) => ( <Question key={i} {...props} /> ))}
        
            {feedback.map((props, i) => ( <Feedback key={i} {...props} /> ))}
            
        </div>;
    }

    return '';
}

export default ConnectState(SectionB, 'answers');



// WEBPACK FOOTER //
// ./src/sections/b.js